import React, { useState } from 'react';
import './Karmaquiz.css';


const questions = [
  {
    question: "when was the last time you rolled a stop sign?",
    options: ["I can’t remember rolling one", "High school", "The last time I drove (who knows when that was)", "This week or in the very memorable past", "today", "It was soooo late and I just wanted to get home"],
    points: [0, 1, 2, 3, 4, 2] // could assign different scores
  },
  {
    question: "are you good to your mother?",
    options: ["She isn’t good to me so don’t go there", "only when i'm in a good mood", "my mom is my best friend in the whole world", "i talk to her, i see her, but I'll admit i can be rude", "we get along but if she knew the real me she'd be so disappointed"],
    points: [1, 3, 0, 2, 3],
  },
  {
    question: "are you honest to your partner/ex?",
    options: ["no, never", "of course I can't help but tell them every little thing", "only about stuff that won't get me in trouble", "yes because i know they won't leave me no matter what i do", "i try but i also need my privacy"],
    points: [4, 0, 3, 5, 2],
  },
  {
    question: "who are you in your head?",
    options: ["i judge every single person i see", "i'm quite self absorbed, yes this includes you if you're constantly worried about what others think of you", "deep in thought about the most random assortment of things", "wondering the next thing i can do to get attention", "someone who wants to know when their next meal is"],
    points: [5, 4, 0, 2, 1],
  },
  {
    question: "How often do you talk shit on your friends?",
    options: ["Thats insane", "Only the ones I dont like, when I hear that others also dont like them", "I do but its okay not to find your friends perfect", "Of course but they talk about me too so its even", "Only only only to my mom"],
    points: [0, 2, 5, 4, 1],
  },
  {
    question: "How often do you take your bad moods out on others?",
    options: ["If im grumpy, watch your mf back", "Only to my partner, but they know how to handle it", "I dont do that I control my emotions", "I snap every once in awhile when someone is fr pushing my buttons", "I just go silent mode tbh"],
    points: [5, 3, 0, 2, 1],
  },
  {
    question: "Do you steal?",
    options: ["No its stupid and against the law", "Only from massive corporations", "Yes, if I want something I just take it", "Nah but I don’t really judge people who do, as long as they dont cause too much harm", "I might if I were slick"],
    points: [0, 2, 4, 1, 0],
  },
  {
    question: "What character from Friends do you most relate to?",
    options: ["Ross", "Rachel", "Joey", "Chandler", "Monica", "Phoebe"],
    points: [5, 4, 0, 3, 2, 0],
  },
  {
    question: "If there are no real-life consequences for your actions, nor any real harm to anyone, do you feel guilt?",
    options: ["Sounds like I didnt do anything wrong then", "Yes there are times when I did the wrong thing, but the universe gave me a break", "Like maybe a tiny itty bitty bit but I would move on real fast", "No, literally who cares?", "I will probably do it again"],
    points: [4, 2, 3, 3, 5],
  },
  {
    question: "You find someone hot. Youre around them all the time, but they are taken. How do you act?",
    options: ["Cordial, normal, friendly", "Kind of cold, dont want them to think im flirting", "Obviously im going to flirt just a bit. But thats harmless ", "im attentive, understanding, kind, and laugh at all their jokes", "Im myself as always"],
    points: [0, 1, 5, 4, 2],
  },
  {
    question: "Who do you unfollow on instagram?",
    options: ["I do not unfollow people", "As soon as I dont know them I unfollow, even if theyre following me", "People who I just dont care about anymore", "Different people, but I always remove them as a follower too", "Only big accounts that I dont care about"],
    points: [0, 2, 3, 1, 0],
  },
  {
    question: "When you want to know something, how do you get your answer?",
    options: ["Chat GPT", "Google", "My parents", "My partner", "I do not look for the answer whatsoever"],
    points: [4, 0, 1, 1, 1],
  },
  
  // Add more questions
];

function Karmaquiz() {
  const [currentQ, setCurrentQ] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (points) => {
    setScore(score + points);
    const next = currentQ + 1;
    if (next < questions.length) {
      setCurrentQ(next);
    } else {
      setShowResult(true);
    }
  };

  const getResult = () => {
    if (score >= 2 && score <= 12) return "Free for now";
    else if (score >= 13 && score <= 24) return "karma clouds forming ahead";
    else if (score >= 25 && score <= 36) return "you're being watched";
    else if (score >= 37 && score <= 47) return "the ice is thin, turn back now";
    else return "Karmic Disaster";
  };
  

  return (
    <div className="karmaquiz-page">
    <div className="quiz-container">
      <h1 className="quiz-title">Is karma coming for you??</h1>
  
      {showResult ? (
        <div className="quiz-result">
          <h2 className="result-heading">You are: {getResult()}</h2>
        </div>
      ) : (
        <>
          <h2 className="quiz-question">{questions[currentQ].question}</h2>
  
          <div className="quiz-options">
            {questions[currentQ].options.map((opt, index) => (
              <button
                key={index}
                className="quiz-option"
                onClick={() => handleAnswer(questions[currentQ].points[index])}
              >
                {opt}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
    </div>
  );

  }
  

export default Karmaquiz;
